import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../data/content";
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);
  return <header className="fixed inset-x-0 top-0 z-50 md:pt-6" data-id="element-182" data-mp="1yo3wdp8hpy7c">
      <nav className="container-x !px-0 md:!px-[var(--gutter)]" aria-label="Main" data-id="element-183" data-mp="23q1kawru5h6m">
        <div className={`flex h-16 items-stretch border-b border-hairline transition-[background-color] duration-150 md:border ${scrolled ? "bg-ink/85 backdrop-blur-md" : "bg-ink/30 backdrop-blur-[2px]"}`} data-id="element-184" data-mp="1y66zfbxyym5t">
          <div className="flex items-center border-r border-hairline px-5 md:px-6" data-id="element-185" data-mp="1p7cxr75s75le">
            <Logo data-id="element-186" data-mp="1k80ailazzwia" />
          </div>
          <ul className="hidden flex-1 items-stretch lg:flex" data-id="element-187" data-mp="2htxvcpcuodxe">
            {navLinks.map(link => <li key={link.href} className="border-r border-hairline" data-id="element-188" data-mp="2cv37h900zz6f">
                <a href={link.href} className="flex h-full items-center px-4 font-mono xl:px-7 text-[13px] tracking-[0.1em] text-body transition-colors duration-150 hover:bg-white/[0.04] hover:text-white" data-id="element-189" data-mp="2cwxpaeg03b6a">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <div className="ml-auto flex items-center gap-1 pl-3 pr-2 md:px-2.5 lg:border-l lg:border-hairline" data-id="element-190" data-mp="2vsnusbn56pox">
            <a href="#book" className="btn-graphite !px-4 sm:!px-[26px]" data-id="element-191" data-mp="txgfapbmib87">
              <span className="roll inline-block sm:hidden" data-id="element-192" data-mp="xy0a3m8q52r6"><span data-id="element-193" data-mp="xzuv10jzwuv9">START</span></span>
              <span className="roll hidden sm:inline-block" data-id="element-194" data-mp="k6vgp1vy96pa"><span data-id="element-195" data-mp="k5u2iojn043c">START YOUR FILM</span></span>
            </a>
            <button type="button" className="flex h-11 w-11 items-center justify-center text-white lg:hidden" aria-label="Open menu" aria-expanded={open} onClick={() => setOpen(true)} data-id="element-196" data-mp="p4n7ttorsosf">
              <MenuIcon className="h-6 w-6" data-id="element-197" data-mp="17hig7r6t9sz" />
            </button>
          </div>
        </div>
      </nav>

      <AnimatePresence data-id="element-198" data-mp="66kljmnlx5yb">
        {open && <motion.div role="dialog" aria-modal="true" aria-label="Menu" className="fixed inset-0 z-[60] flex flex-col bg-black" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-199" data-mp="67dosdncxdbp">
            <div className="container-x flex h-[72px] items-center justify-between" data-id="element-200" data-mp="25pz64bi72o90">
              <Logo data-id="element-201" data-mp="2jgu9x9du6f5q" />
              <button type="button" className="flex h-11 w-11 items-center justify-center text-white" aria-label="Close menu" onClick={() => setOpen(false)} data-id="element-202" data-mp="2jh3xyrfbmc8s">
                <XIcon className="h-6 w-6" data-id="element-203" data-mp="2td6zpw69g8v7" />
              </button>
            </div>
            <ul className="container-x mt-10 flex flex-col gap-2" data-id="element-204" data-mp="2of5htekkmflb">
              {navLinks.map(link => <li key={link.href} data-id="element-205" data-mp="32f6jgw8ntr1u">
                  <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-quiet py-4 font-serif text-[44px] leading-none tracking-[-0.02em] text-white" data-id="element-206" data-mp="2ye4q2w1fc97s">
                    {link.label.charAt(0) + link.label.slice(1).toLowerCase()}
                  </a>
                </li>)}
            </ul>
            <div className="container-x mt-auto pb-10" data-id="element-207" data-mp="1afu9lyg6gij1">
              <a href="#book" onClick={() => setOpen(false)} className="btn-graphite w-full" data-id="element-208" data-mp="1aeiwv94r80fs">
                <span className="roll inline-block" data-id="element-209" data-mp="1eiqjn0rnj6bd"><span data-id="element-210" data-mp="1jgs3hnwwj9nw">START YOUR FILM</span></span>
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}